import classNames from "classnames";
import { FollowInfo, FollowInfoProps } from "./FollowInfo";
import { UserInfo, UserInfoProps } from "./UserInfo";

type UserCardProps = UserInfoProps &
  FollowInfoProps & {
    className?: string;
  };

export const UserCard: React.FC<Partial<UserCardProps>> = ({
  handle,
  token,
  type,
  timeStamp,
  postId,
  screenName,
  className,
  icon,
}) => {
  return (
    <div
      className={classNames(
        "overflow-hidden rounded-[9px] h-[32px] w-[287px] relative flex justify-center items-center flex-shrink-0",
        "animate-gradient-rotate",
        className,
      )}
    >
      <div className="flex items-center h-[30px] w-[285px] px-2 py-2 bg-background_solid_primary rounded-[9px] z-10 gap-4">
        <UserInfo token={token} icon={icon} />
        <FollowInfo
          type={type}
          timeStamp={timeStamp}
          handle={handle}
          postId={postId}
          screenName={screenName}
        />
      </div>
    </div>
  );
};
